import {defineField, defineType} from 'sanity'
import {BsJournalRichtext} from 'react-icons/bs'

export default defineType({
  name: 'content-section',
  title: 'Content Section',
  type: 'object',
  icon: BsJournalRichtext,
  fields: [
    defineField({
      name: 'content',
      type: 'portableTextContent',
    }),
  ],
  preview: {
    select: {
      content: 'content',
    },
    prepare() {
      return {
        title: 'content',
      }
    },
  },
})
